// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from "vuex";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import App from "./App";
import router from "./router";
import axios from "axios";
import JSMpeg from "./utils/jsmpg";
import VueI18n from "vue-i18n";
import locale from "element-ui/lib/locale";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";
import zh from './i18n/lang/zh';
import en from './i18n/lang/en';
// import "./utils/utils"
// import store from './store';
import { systemInfo, getMapInfo, xinruikcAuth, getRouters, downLoadFileExport } from "./api/api";
Vue.config.productionTip = false;

import Directives from "./directives/index";
Vue.use(Directives);

Vue.use(Vuex);
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'cn',
    messages: {
        'cn': Object.assign(zh, zhLocale),
        'en': Object.assign(en, enLocale)
    }
});
const languageData = {
    'cn': zh,
    'en': en
}
Vue.prototype.$t = function (keys) {
    // if(i18n.locale=='cn')return keys;
    // let result = "";
    // result = i18n.messages[i18n.locale][keys];
    // return result == undefined ? keys : result;
    let language = store.state.userInfo == null ? store.state.language : store.state.userInfo.language;
    let result = languageData[language][keys];
    return result == undefined ? keys : result;
}
Vue.use(ElementUI, {
    i18n: ((key, value) => i18n.t(key, value))
});
// 引入全局过滤器
import * as filters from "@/filters/filters";
// 注册全局过滤器
Object.keys(filters).forEach(v => {
    Vue.filter(v, filters[v]);
});

// 全局属性存储


const store = new Vuex.Store({
    state: {
        count: 0,
        configName: "",
        logoUrl: "",
        // liveHttpPrefix: "",
        // liveWsPrefix: "",
        token: "",
        version: "",
        copyright: "",
        userName: "",
        defaultLayerId: "",
        breadcrumb: [],
        mapConfig: {},
        menuList: [],
        dict: {},
        language: 'cn',
        userInfo: { language: 'cn' },
        largeScreenJson: {},
        systemId: '',
        locationPassage: {},
        linkList: [],
        editLinkList: [],
        hideElement: '',
        hideElementArr: {
            hideCamera: true,
            hideLamp: true,
            hideBigScreen: true,
            hideRiskZoning: true,
            hideSBigScreen: true,
            hideSassBigScreen: true,
        },
        templateLanguage: '',
        tracingPoint: "N",
        btnArray: [],
        toolsHideElementNum: 0,
        currentVehicleLocationTotal:0,
    },
    mutations: {
        increment(state) {
            state.count++;
        },
        setLocationPassage(state, msg) {
            state.locationPassage = msg;
        }
    }
});

    localStorage.setItem("urlId",router.history.base)
    window.urlId = router.history.base
    let $_base_hose = window.location.host; //格式：127.0.0.1:8849
    let $_origin = window.location.origin; //格式：http://127.0.0.1:8849
    // if(){//线上调试模式
    // $_base_hose = "219.150.138.155:18081/";
    // $_origin = "http://" + $_base_hose;
    // $_origin = "http://219.150.138.155:18081/";
    // }
    let protocol = window.location.protocol == 'http:' ? 'ws://' : 'wss://';
    window.httpUrl = $_origin + window.urlId + "/gateway-service/";
    if(window.config.fixedWsUrl) {
        window.WebSocketUrl = window.config.fixedWsUrl + "/gateway-service/websocket/ws/"
    } else {
        window.WebSocketUrl = protocol + $_base_hose + window.urlId + "/gateway-service/websocket/ws/";
    }
    // 图片
    window.fileUrl = $_origin + window.urlId + "/gateway-service/fileStatic/";
    // 视频
    window.liveHttpPrefix = $_origin + window.urlId + "/live-service/live";
    window.liveWsPrefix = protocol + $_base_hose + window.urlId +  "/live-service/live";
    if (process.env.NODE_ENV === "development") {
        // dev
        // let dev_host = "192.168.0.199:9090";
        // let dev_host=window.location.host
        let host = "xinruikc.qicp.io";
        let dev_host = host + ":8099";
        // let host = "192.168.0.110";
        // let dev_host = host + ":8090";
        // host = "1.180.88.14";
        // dev_host = host + ":12309";
        window.urlId = ''
        window.httpUrl = "http://" + dev_host + window.urlId + "/gateway-service/";
        if(window.config.fixedWsUrl) {
            window.WebSocketUrl = window.config.fixedWsUrl + "/gateway-service/websocket/ws/";
        } else {
            window.WebSocketUrl = protocol + dev_host + window.urlId + "/gateway-service/websocket/ws/";
        }
        window.fileUrl = window.httpUrl +  window.urlId + "/fileStatic/";
        let dev_live_host = host + ":8090";
        let dev_live_origin = "http://" + host + ":8090";
        // window.liveHttpPrefix = dev_live_origin + "/live";
        // window.liveWsPrefix = "ws://" + dev_live_host + "/live/webSocket/live/";
        window.liveHttpPrefix = dev_live_origin +  window.urlId + "/live-service/live";
        window.liveWsPrefix = "ws://" + dev_live_host +  window.urlId + "/live-service/live";
    }
    

    const getUrlId = async() => {
        if (window.urlId) {
            let userCodeS = localStorage.getItem("userCodeS")
            if(!userCodeS) {
                router.push({ path: '/login' });
                return
            }
            let res = await get(httpUrl + "/monitor-service/auth/getAuthToken?org=sinopec&&token=" + userCodeS)
            if(res.code==200) {
                store.state.token = res.data.token;
                window.setCookie("token", res.data.token, 365);
                window.setCookie("userInfo", JSON.stringify(res.data.userInfo), 365);
            }else{
                router.push({ path: '/404' });
                return
            }
        }
    } 
    getUrlId()

window.layerMoveSpeed = 8;
if (config.layerMoveSpeed) {
    window.layerMoveSpeed = config.layerMoveSpeed;
}
window.downLoadFail = function (res, name) {
    let blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = name;
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    //释放内存
    window.URL.revokeObjectURL(link.href)
};
window.downLoadFile = function (uuid, module, fileName) {
    downLoadFileExport({
        uuid: uuid,
        module: module
    }).then(res => {
        let blob = new Blob([res], {
            type: "application/vnd.ms-excel"
        });
        let objectUrl = URL.createObjectURL(blob);
        var btn = document.createElement("a");
        btn.id = "download";
        btn.setAttribute("download", fileName);
        btn.setAttribute("href", objectUrl);
        btn.click(); // 自执行点击事件
        btn.remove();
    })
}
window.download = function (url, query, fileName) {
    var url = window.httpUrl + url;
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.responseType = "blob";
    var token = getCookie("token");
    xhr.setRequestHeader("Authorization", token);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onload = function () {
        if (this.status === 200) {
            // var blob = this.response;
            let blob = new Blob([this.response], {
                type: "application/vnd.ms-excel"
            });
            let objectUrl = URL.createObjectURL(blob);
            var btn = document.createElement("a");
            btn.id = "download";
            btn.setAttribute("download", fileName);
            btn.setAttribute("href", objectUrl);
            btn.click(); // 自执行点击事件
            btn.remove();
        }
    };
    query = {
        ...query,
        pageFlag: "N"
    }
    var query = JSON.stringify(query);
    xhr.send(query);
};
let _getTenant = function () {
    // window.setCookie("tenant", window.tenant, 365);
    let result = window.post(httpUrl + "/monitor-service/systemTenant/findByRoute", {
        route: window.tenant,
        tenantId: getCookie("Location_Tenant_Id"),
        token: getCookie("token"),
    });
    // if (result.data)
    if (result.code == 200) {
        window.tenantObj = result.data;
        window.setCookie("tenantObj", JSON.stringify(result.data), 365);
        window.Location_Tenant_Id = result.data.id;
        window.setCookie("Location_Tenant_Id", result.data.id, 365);
        window.tenant = result.data.route;
        window.setCookie("tenant", result.data.route, 365);
        console.log(result.data.route)
        // store.state.configName = result.data.name;
        // store.state.systemType = result.data.systemType;
        // store.state.logoUrl = window.fileUrl + result.data.logo;
    }
}
// sass企业租户
window.tenantObj = getCookie("tenantObj");
window.tenantObj = (window.tenantObj ? {} : JSON.parse(tenantObj));
window.tenant = getCookie("tenant");
window.Location_Tenant_Id = "";
// if (window.tenant) _getTenant();
let overtimeStatic = false;
const overtimeError = function () {
    // 免登录白名单
    if (window.location.pathname.includes("login") || window.location.pathname.startsWith('/RYDWYY') || window.location.pathname.includes("404") || window.location.pathname.includes("cardDispenserPerson1") || window.location.pathname.includes("cardDispenserRent") ) return;

    if (!overtimeStatic) {
        ElementUI.Message.error("登录信息已失效，请重新登录");
        store.state.token = "";
        // delCookie("token");
        window.emptyCookie();
        overtimeStatic = true;
        let path = "/login";
        if (window.tenant) path = "/" + window.tenant + path;
        // 不要用location进入页面不然会影响RYDWYY，进入页面回调
        router.push({ path: path });
        // window.location.href = path;
    }
}
// 配置axios
Vue.prototype.$http = axios;
// 获取用户信息
let getUserInfo = function (keys) {
    let res = post(httpUrl + "/monitor-service/user/ignoreGetAuthInfo", { 'xinruikcAuth': keys });
    if (res.code == 200) {
        try {
            // console.log("setUserinfo")
            setCookie("userInfo", JSON.stringify(res.data.userInfo));
            // 根据接口获取租户id，来请求免密
            store.state.systemType = res.data.systemType;
            setCookie("Location_Tenant_Id", res.data.tenantId);
            window.Location_Tenant_Id = res.data.tenantId;
            if (window.Location_Tenant_Id) _getTenant();
            getSystemconfig();
            getSystemInfo();
            // console.log(res.data.userInfo)
            store.state.language = res.data.userInfo.language;
        } catch (e) {
            console.log(e)
        }
    } else {
        // ElementUI.Message.error("登录信息已失效，请重新登录");
        overtimeError();
        console.log("get userinfo error！");
    }
}
// 获取系统配置
window.systemconfig = {
    rail_color: "#00D500",
    alarm_audio_loop: "N",
    hide_element: ""
};
let getSystemconfig = function (keys) {
    let res = post(httpUrl + "/monitor-service/config/listMap", {});
    if (res.code == 200) {
        systemconfig = Object.assign(systemconfig, res.data);
        // console.log(systemconfig)
        window.UEUrl = systemconfig.UEUrl;
        window.UECoontMax = parseInt(systemconfig.UECoontMax);
        window.UEDefaultHeight = parseInt(systemconfig.UEDefaultHeight);
        if (systemconfig.alarm_audio_loop == "Y") {
            document.getElementById("alarmAudio").loop = true;
            document.getElementById("alarmAudio").load();
        } else {
            document.getElementById("alarmAudio").loop = false;
            document.getElementById("alarmAudio").load();
        }
    } else {
        console.log("get systemconfig error！");
    }
}

store.state.userName = getCookie("userName");
// 获取系统信息
store.state.userInfo = JSON.parse(getCookie("userInfo"));
let getSystemInfo = () => {
    systemInfo().then(res => {
        if (res.code == 200) {
            window.sys_info = res;
            window.targetIndex = sys_info.data.targetIndex;
            window.defaultLayerId = sys_info.data.defaultLayerId;
            store.state.configName = res.data.systemName;
            store.state.logoUrl = fileUrl + res.data.logoUrl;
            store.state.version = res.data.version;
            store.state.copyright = res.data.copyright;
            store.state.mapType = res.data.mapType;
            store.state.defaultLayerId = res.data.defaultLayerId;
            store.state.largeScreenJson = res.data.largeScreenJson;
            store.state.systemId = res.data.systemId;
            store.state.language = res.data.language;
            store.state.hideElement = res.data.hideElement||"";
            store.state.tracingPoint = res.data.tracingPoint;
            window.largeScreenTheme = res.data.largeScreenTheme;
            setCookie("largeScreenTheme", largeScreenTheme, 3650);
            window.TDTTK = res.data.mapWorldKey;
            document.title = res.data.systemName;
            store.state.toolsHideElementNum = 0;
            if (store.state.hideElement) {
                let arr = store.state.hideElement.split(",")
                if (arr.includes("hideCamera")) {
                    store.state.hideElementArr.hideCamera = false;
                    store.state.toolsHideElementNum++;
                }
                if (arr.includes("hideLamp")) {
                    store.state.hideElementArr.hideLamp = false;
                    store.state.toolsHideElementNum++;
                }
                if (arr.includes("hideBigScreen")) {
                    store.state.hideElementArr.hideBigScreen = false;
                }
                if (arr.includes("hideRiskZoning")) {
                    store.state.hideElementArr.hideRiskZoning = false;
                    store.state.toolsHideElementNum++;
                }
                if (arr.includes("hideSBigScreen")) {
                    store.state.hideElementArr.hideSBigScreen = false;
                }
                if (arr.includes("hideSassBigScreen")) {
                    store.state.hideElementArr.hideSassBigScreen = false;
                }
            }
        } else {
            ElementUI.Message.error(res.msg);
        }
    });
}

if (getCookie("userInfo")) {
    if (JSON.parse(getCookie("userInfo")).language == 'en') {
        store.state.templateLanguage = "-" + JSON.parse(getCookie("userInfo")).language
    } else {
        store.state.templateLanguage = ""
    }
    if (JSON.parse(getCookie("userInfo")).skin == 'theme99') {
        document.body.style.setProperty('--btnBackground', '#4976f3');
        document.body.style.setProperty('--btnColor', '#fff');
        document.body.style.setProperty('--btnBorderColor', '#4976f3');
        document.body.style.setProperty('--breadcrumbColor', '#000');
        document.body.style.setProperty('--btnHoverBackground', '#4976f3');
    }
}
if(window.config.maskTheme) {
    document.body.style.setProperty('--maskTheme', 'none');
}
// 获取按钮权限
let btnArray = [];
window.getButtonTree = function (keys) {
    let res = get(httpUrl + "/system/menu/getPerms", {});
    if (res.code == 200) {
        btnArray = res.data;
    } else {
        console.log("get ButtonTree error！");
        console.log(res);
    }
}
// 判断BTN权限
Vue.prototype.$btn = function (key) {
    return btnArray.includes(key)
}
let org = getQueryString("org");
let tenant = getQueryString("tenant");
if (tenant) setCookie("tenant", tenant, 365);
function getToken() {
    let key = null;
    if (getQueryString("accessToken")) key = getQueryString("accessToken");
    if (getQueryString("token")) key = getQueryString("token");
    let thirdOrg = getQueryString("orgCode");
    if (key) {
        let res = get(httpUrl + "/monitor-service/auth/getAuthToken?org=" + org + "&&token=" + key + "&&thirdOrg=" + thirdOrg);
        if (res.code == 200) {
            key = res.data.token;
        } else {
            ElementUI.Message.error(res.msg);
        }
    } else {
        key = getQueryString("xinruikcAuth");
    }
    if (key) {
        window.emptyCookie();
        window.tenant = "";
    }
    return key;
}
// let urlKey = getQueryString("accessToken");
// urlKey = (urlKey == null ? getQueryString("token") : urlKey);
// if (urlKey == null) {
//     urlKey = getQueryString("xinruikcAuth");
// } else {
//     let res = get(httpUrl + "/monitor-service/auth/getAuthToken?org=" + org + "&&token=" + urlKey);
//     if (res.code == 200) {
//         urlKey = res.data.token;
//     }
// }
// if (urlKey == null) urlKey = getCookie("token");
let urlKey = getToken();
urlKey = (urlKey == null ? getCookie("token") : urlKey);
console.log(urlKey)
if (urlKey) {
    store.state.token = urlKey;
    setCookie("token", urlKey, 3650);
    getUserInfo(urlKey);
} else {
    overtimeError();
}
// console.log("mainjs")
// 修改AJAX默认地址
// axios.defaults.baseURL = window.location.protocol+"//"+store.state.ajaxurl.ajaxUrl6100;
axios.interceptors.request.use(
    function (response) {
        const url = response.url;
        var token = getCookie("token");
        if (token && !url.includes("encryptLogin")) {
            window.oldToken = token;
            response.headers.Authorization = token;
            overtimeStatic = false;
        }
        Location_Tenant_Id = getCookie("Location_Tenant_Id");
        if (Location_Tenant_Id) {
            response.headers['location-tenant-id'] = Location_Tenant_Id;
        }
        return response;
    },
    function (error) {
        // ElementUI.Message.error("网络错误，请刷新重试")
        console.log("网络错误，请刷新重试");
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    res => {
        if (res.data.code == "403") {
            // alert('登录信息已失效，请重新登录');
            // ElementUI.Message.error("登录信息已失效，请重新登录");
            overtimeError();
            // window.location.href="/login";
        }
        if (res.data.code == "205") {
            // ElementUI.Message.error(res.data.msg);
            ElementUI.Message.error('填写不规范(请填写数值)！');
            return false;
            // alert('登录信息已失效，请重新登录');
            // ElementUI.Message.error("登录信息已失效，请重新登录");
            // window.location.href="/login";
        }
        if (res.data.code != 200) {
            // ElementUI.Message.error(res.data.msg);
            // console.log(res.data.msg)
        }
        return res.data;
    },
    err => {
        // ElementUI.Message.error("网络错误，请刷新重试")
        console.log("网络错误，请刷新重试");
        return err;
    }
);

router.beforeEach(async (to, from, next) => {
    ckLayer = "";
    var token = getCookie("token");
    store.state.breadcrumb = to.meta.breadcrumb;
    // 如果islogin为true，则判断token是否存在
    let path = "/login";
    if (window.tenant) path = "/" + window.tenant + path;
    if (to.path == "/login" || to.path == "/") {
        // 如果是登录页跳转到首页
        // if (token) next("/realtimeLocation");
        if (token) {
            if (typeof (sys_info.data) != "undefined") {
                next(sys_info.data.targetIndex);
            } else {
                next("/realtimeLocation_2d");
            }
        }
    }
    if (to.meta.isLogin) {
        if (token) {
            console.log("合法访问");
            console.log("v2.0.38(0119)");
            // getSystemconfig();
            next();
        } else {
            if (!window.location.pathname.startsWith('/RYDWYY')) {
                ElementUI.Message.error("登录信息已失效，请重新登录");
            }
            next({ path:path });
            // console.log(path)
        }
    } else {
        // console.log("next")
        next();
    }
});

console.log(process.env.NODE_ENV);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    i18n,
    router,
    store,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js